/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   Function to check if date is in range
 */
import isAfter from 'date-fns/isAfter'
import isBefore from 'date-fns/isBefore'
import isWithinInterval from 'date-fns/isWithinInterval'

export const isOverIgnored = (
  disabledRanges: ReadonlyArray<readonly [startDate: Date, endDate: Date]> | undefined,
  start: Date,
  end: Date
) =>
  disabledRanges?.find(([startRange]) => {
    const isIn = isWithinInterval(startRange, {
      start,
      end,
    })
    if (isIn) {
      return true
    }
    return false
  })

export const isInIgnored = (
  disabledRanges: ReadonlyArray<readonly [startDate: Date, endDate: Date]> | undefined,
  date: Date
) => {
  return disabledRanges?.find(([startRange, endRange]) => {
    const isIn = isWithinInterval(date, {
      start: startRange,
      end: endRange,
    })
    if (isIn) {
      return true
    }
    return false
  })
}

export const isOnIgnored = (
  disabledRanges: ReadonlyArray<readonly [startDate: Date, endDate: Date]> | undefined,
  disableForeverTo: Date | undefined,
  disableForeverFrom: Date | undefined,
  date: Date
) => {
  const isDisabled = isInIgnored(disabledRanges, date)
  if (isDisabled) {
    return isDisabled
  }

  if (disableForeverFrom) {
    const isAfterDisabled = isAfter(date, disableForeverFrom)
    if (isAfterDisabled) {
      return isAfterDisabled
    }
  }

  if (disableForeverTo) {
    const isBeforeDisabled = isBefore(date, disableForeverTo)
    if (isBeforeDisabled) {
      return isBeforeDisabled
    }
  }

  return false
}
